import CustomerDateFormat from './constants/customerDateFormat'

export const getDateFormat = (dateFormat) => {
  if (dateFormat === CustomerDateFormat.YMD)
    return 'yyyy/MM/dd'
  else if (dateFormat === CustomerDateFormat.DMY)
    return 'dd/MM/yyyy'
  else
    return 'MM/dd/yyyy'
}

export const getDateTimeFormat = (dateFormat, timeFormat = 'h:mm aa') => {
  if (dateFormat === CustomerDateFormat.YMD)
    return 'yyyy/MM/dd' + ' ' + timeFormat
  else if (dateFormat === CustomerDateFormat.DMY)
    return 'dd/MM/yyyy' + ' ' + timeFormat
  else
    return 'MM/dd/yyyy' + ' ' + timeFormat
}

export const getDateOnlyUnixFormat = (format) => {
  if (format === CustomerDateFormat.YMD)
    return 'YYYY/MM/DD'
  else if (format === CustomerDateFormat.DMY)
    return 'DD/MM/YYYY'
  else
    return 'MM/DD/YYYY'
}

export const getDateUnixFormat = (format, timeFormat = 'h:mma') => {
  if (format === CustomerDateFormat.YMD) {
    return 'YYYY/MM/DD' + ' ' + timeFormat
  } else if (format === CustomerDateFormat.DMY) {
    return 'DD/MM/YYYY' + ' ' + timeFormat
  } else {
    return 'MM/DD/YYYY' + ' ' + timeFormat
  }
}
